
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class StatCard extends Vue {
  @Prop({ default: 0 })
  statValue!: number;

  @Prop({ default: "" })
  statName!: string;

  @Prop({ default: true })
  loading!: boolean;

  get displayValue() {
    if (this.loading) {
      return "";
    }
    return this.statValue;
  }
}
